export const productStatusLabel = (status?: string) => {
    const value = status?.trim().toLowerCase();
    return value ? value[0].toUpperCase() + value.slice(1) : '—';
};
